import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import DesktopHeader from '../header/DesktopHeader';
import Footer from '../Footer';
import Sidebar from '../Sidebar';

const drawerWidth = 240;

const styles = {
  drawer: {
    width: drawerWidth,
    '& .MuiDrawer-paper': {
      width: drawerWidth,
      boxSizing: 'border-box',
      background: '#ffffff',
      color: '#22467F',
    },
  },
};

const Layout = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '240px 1fr',
  gridTemplateRows: '122px 1fr',
  gridTemplateAreas: `
    "header header"
    "sidebar content"
    "footer footer"
  `,
  height: '100vh',
  overflow: 'hidden',
});

const Header = styled(Box)({
  gridArea: 'header',
});

const Content = styled(Box)({
  gridArea: 'content',
  padding: '0px',
  background: 'rgb(20,54,98)',
});

const SidePanel = styled(Box)({
  gridArea: 'sidebar',
  background: '#fff',
  padding: '10px',
  color: 'rgb(20,54,98)',
});

const FooterBox = styled(Box)({
  paddingTop: 0,
  gridArea: 'footer',
});

const AdminLayout = () => (
  <Layout>
    <Header>
      <DesktopHeader />
    </Header>
    <SidePanel sx={styles.drawer}>
      <Sidebar />
    </SidePanel>
    <Content>
      <Outlet />
    </Content>
    <FooterBox>
      <Footer />
    </FooterBox>
  </Layout>
);
export default AdminLayout;
